<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title v-if="!!alertNotification" :text="alertNotification.title"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-read-accuses-filters @filter="onFilter"></app-read-accuses-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-read-accuses-indicators
                    :audience-size="audienceSize"
                    :coverage="coverage"
                    :coverage-percentaje="coveragePercentaje"
                ></app-read-accuses-indicators>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-read-accuses-list
                    v-if="!!accuses"
                    :accuses="accuses"
                    @on-change-page="onChangePage"
                ></app-read-accuses-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import ReadAccusesList from './ReadAccusesList/ReadAccusesList';
import comunicationsRepository from '@repositories/comunications.repository';
import ReadAccusesFilters from './ReadAccusesFilters/ReadAccusesFilters';
import ReadAccusesIndicators from './ReadAccusesIndicators/ReadAccusesIndicators';
export default {
    components: {
        appReadAccusesList: ReadAccusesList,
        appReadAccusesFilters: ReadAccusesFilters,
        appReadAccusesIndicators: ReadAccusesIndicators
    },
    props: {
        alertNotification: {
            type: [Object, String],
            required: true
        }
    },
    data: () => ({
        accuses: null,
        page: 1,
        filters: '',
        audienceSize: 0,
        coverage: 0,
        coveragePercentaje: 0,
    }),
    watch: {
        alertNotification(val) {
            if(!!val) {
                this.loadAccuses();
                this.loadAccuseIndicators();
            }
        }
    },
    methods: {
        onChangePage(page) {
            this.page = page;
            this.loadAccuses();
        },
        async loadAccuses() {
            const cr = {...comunicationsRepository};
            try {
                const { data } = await cr.getReadAccuses({...this.filters, alertNotificationId: this.alertNotification.id, page: this.page});
                const tableData = data.data.map(item => {
                    const isAudience = this.alertNotification.profiles.split(',').includes(item.profileSlug) && this.alertNotification.cities.split(',').includes(item.citySlug);
                    const classes = !isAudience? 'alert alert-info': (!!item.created_at? 'alert alert-success': 'alert alert-danger');
                    return {...item, isAudience, classes};
                });
                
                this.accuses = {...data, data: tableData.sort((a, b) => a.isAudience && b.isAudience? 1: -1)};
            }catch(err) {
                this.handleErrors(err);
            }
        },
        async loadAccuseIndicators() {
            const cr = {...comunicationsRepository};
            try {
                const { data } = await cr.getReadAccuseIndicators(this.alertNotification.id);
                this.audienceSize = data.audienceSize;
                this.coverage = data.coverage;
                this.coveragePercentaje = data.coveragePercentaje;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        onFilter(filters) {
            this.page = 1;
            this.filters = filters;
            this.loadAccuses();
        }
    }
}
</script>
<style lang="css" scoped>
    .no-audience {
        text-decoration: overline;
    }
</style>